 // カートカウントの実装
 //Swymのボタンに直接イベントを追加
window.addEventListener('load', function () {

  // Swymのボタンに直接イベントを追加
  setTimeout(() => {
    const buttons = document.querySelectorAll('.swym-add-to-cart-btn');
    buttons.forEach((btn, index) => {

      btn.addEventListener('click', () => {

        // Swymが商品追加を完了するまで少し待ってカート取得
        setTimeout(() => {
          fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
              const badge = document.querySelector('.cart-count-badge');
              if (badge) {
                if (cart.item_count > 0) {
                  badge.textContent = cart.item_count;
                  badge.style.display = 'inline-block';
                } else {
                  badge.style.display = 'none';
                }
              }
            })
        }, 1500); // Swymが処理完了する時間を待つ
      });
    });
  }, 3000); // SwymのDOM描画完了を待つ
});